/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * PlannerDisplay: customer display component
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
import { formatRoles } from "../../../services/utils/utils";
/***/

/*
* PlannerDisplay: customer display component
* Used to display a customer entity
*/

export interface PlannerDisplayProps extends GenericDisplayProps {
  planner: any
}

class PlannerDisplay extends GenericDisplay<PlannerDisplayProps> {
  getData = (() => {
    const rolesString = formatRoles(this.props.planner.roles);
    
    return (
      <div className="flex gap-2">
        <Typography className="et-overflow-ellipsis">
          { this.props.planner.firstName }
        </Typography>
    
        <Typography className="text-gray-500 et-overflow-ellipsis"> 
          { this.props.planner.lastName } 
          ({rolesString})
        </Typography>
      </div>
    );
  });
}

export default PlannerDisplay;
/***/